import { defineFetch } from 'resift';
import * as Types from 'pages/Features/typings';

const makeUpdateDefaultPersonSettings = defineFetch({
  displayName: 'Update default person settings',
  make: () => ({
    key: [],
    request: (data: Types.PersonSettings) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/default-settings/person`,
        data,
      }),
  }),
});

const updateDefaultPersonSettings = makeUpdateDefaultPersonSettings();

export default updateDefaultPersonSettings;
